import { REDUX_LOCAL_KEY_PREFIX } from '@gymaholic/packages'

export const USER_PASSWORD_LOCAL_KEY = `${REDUX_LOCAL_KEY_PREFIX}password`

export const YEARLY_SUBSCRIPTION_PERCENTAGE_OFF = 25
export const YEARLY_SUBSCRIPTION_PERCENTAGE_OFF_LABEL = `${YEARLY_SUBSCRIPTION_PERCENTAGE_OFF}%`
